import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Operations } from 'src/app/_models/Operations/Operations';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';

interface City {
  name: string,
  code: string
}

@Component({
  selector: 'app-single-select-venue',
  templateUrl: './single-select-venue.component.html',
  styleUrls: ['./single-select-venue.component.scss']
})

export class SingleSelectVenueComponent implements OnInit {
  // subscription: Subscription;
  // public venuesList?: VenueModelResponse[] = [];
  public venuesList: VenueModelResponse[] = [];
  @Input() list:any[] = [];
  @Input() operation:number = Operations.Add;
  @Input() venueId: string = "";

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareTypesIDs = new EventEmitter();
  @Output() shareIndividualCheckedTypeList = new EventEmitter();

  @Output() shareSelectedItem = new EventEmitter();

  checkedList: any[];
  typesIds: any[];
  currentSelected: {};
  showDropDown: boolean = false;

  selectedVenue: any;

  constructor(private apiService: ApiService) {
    this.checkedList = [];
    this.typesIds = [];
    this.currentSelected = {}
   }

  ngOnInit(): void {
    this.fetchVenues();
  }

  fetchVenues() {
    this.apiService.listVenuesForCombo().subscribe((result)=>{
      this.venuesList = result;
      if(this.venuesList != undefined) {
        this.venuesList.forEach(element => {
          element.checked = false;
          //only when we know the venueId, Open,Read EventDetails
          if(element.id == this.venueId){
            this.selectedVenue = element;
          }
        });
      }
      // console.log(this.venuesList);
    });
  }

  getSelectedValue(status: any, value: any, id: any) {
    
    this.currentSelected = { 
      checked: status,
      name: value
    };
  }

  shareSelectedVenueItem() {
    this.shareSelectedItem.emit(this.selectedVenue);
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }

  shareTypesIds() {
    this.shareTypesIDs.emit(this.typesIds);
  }

  shareIndividualStatus() {
    this.shareIndividualCheckedTypeList.emit(this.currentSelected);
  }

}
